import axios from 'axios';
import { Result } from '@/OptimusRoutes/interfaces';
import { StripePlan, StripePlans } from '../stripeRoutes/entities/stripePlans.entity';
import { PageResult } from '../stripeRoutes/types/service.type';

const getStripePlans = async (search: string, page: number, pageSize: number): Promise<PageResult<StripePlans>> => {
	const { data } = await axios.get<Result<PageResult<StripePlans>>>(
		`/v2/stripe/plans?take=${pageSize}&page=${page}`,
		{ params: { search } }
	);
	return data?.success ?? ({} as PageResult<StripePlans>);
};

const addStripePlan = async (stripePlan: StripePlan): Promise<Result<StripePlans>> => {
	const { data } = await axios.post('/v2/stripe/plan', stripePlan);
	return data;
};

const editStripePlan = async (id: number, stripePlan: StripePlan): Promise<Result<StripePlans>> => {
	const { data } = await axios.patch(`/v2/stripe/plan/${id}`, stripePlan);
	return data;
};

const deleteStripePlan = async (id: number): Promise<void> => {
	return await axios.delete(`/v2/stripe/plan/${id}`);
};

type StripePlansType = {
	getStripePlans: (search: string, page: number, pageSize: number) => Promise<PageResult<StripePlans>>;
	addStripePlan: (values: StripePlan) => Promise<Result<StripePlans>>;
	editStripePlan: (id: number, stripePlan: StripePlan) => Promise<Result<StripePlans>>;
	deleteStripePlan: (id: number) => Promise<void>;
};

const StripePlansService: StripePlansType = {
	getStripePlans,
	addStripePlan,
	editStripePlan,
	deleteStripePlan,
};

export default StripePlansService;
